import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { App } from 'vue'

export default {
  install(app: App) {
    // Pinia
    const pinia = createPinia()

    // Use Pinia plugin for persisted state
    pinia.use(piniaPluginPersistedstate)

    // Use Pinia
    app.use(pinia)
  },
}
